import axios, { CancelToken } from "axios";
import { ENV_CONFIG } from "../constants/index";

function getConfig(accessToken, multipart) {
  let source = CancelToken.source();
  let cancel, config;
  // Return the cancel function and add it to the header.
  // See: https://github.com/mzabriskie/axios#cancellation
  config = {
    cancelToken: source.token,
    source,
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": multipart ? "multipart/form-data" : "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return {
    cancel,
    config,
  };
}

export function webapiGet(accessToken, url) {
  const config = getConfig(accessToken);
  return {
    request: axios
      .get(`${ENV_CONFIG.baseURL}${url}`, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiPut(accessToken, url, options) {
  const config = getConfig(accessToken);
  return {
    request: axios
      .put(`${ENV_CONFIG.baseURL}${url}`, options, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiMultipartPut(accessToken, url, options) {
  const config = getConfig(accessToken, true);
  return {
    request: axios
      .put(`${ENV_CONFIG.baseURL}${url}`, options, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiPost(accessToken, url, options) {
 // Checking if the URL belongs to the refill management or event management module

 let baseURL;
 if(url && typeof url === 'string'){
  const isRefillModule = url.startsWith('/refill-management');
  const isEventModule = url.startsWith('/event-mgmt-service');
  // Determine the base URL
  if (isRefillModule && ENV_CONFIG.refillURL) {
    baseURL = ENV_CONFIG.refillURL;
  } else if (isEventModule && ENV_CONFIG.eventApiURL) {
    baseURL = ENV_CONFIG.eventApiURL;
  } else {
    baseURL = ENV_CONFIG.baseURL;
  }
 }
 else{
  baseURL = ENV_CONFIG.baseURL
 }

  const config = getConfig(accessToken);
  return {
    request: axios
      .post(`${baseURL}${url}`, options, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}
export function webapiPostNew(accessToken, url, options) {
  const config = getConfig(accessToken);
  return {
    request: axios
      .post(`${ENV_CONFIG.analyticsBaseURL}${url}`, options, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiMultipartPost(accessToken, url, options) {
  const config = getConfig(accessToken, true);
  return {
    request: axios
      .post(`${ENV_CONFIG.baseURL}${url}`, options, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiDelete(accessToken, url, options) {
  const config = getConfig(accessToken);
  if (options) config.config.data = options;
  return {
    request: axios
      .delete(`${ENV_CONFIG.baseURL}${url}`, config.config)
      .then((response) => response)
      .catch((err) => err),
    cancel: config.cancel,
  };
}

export function webapiAuthPost(url, options) {
  return {
    request: axios
      .post(`${ENV_CONFIG.baseURL}${url}`, options)
      .then((response) => response)
      .catch((err) => err),
  };
}
